import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { CALYPSO } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
// @ts-expect-error untyped dependency
import { getAssetBusinessTypeI18nKey } from 'ecosystem-marketplace-core/utils/i18n';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import MainSection from 'ecosystem-marketplace-core/components/layout/MainSection';
import MainSectionInner from 'ecosystem-marketplace-core/components/layout/MainSectionInner';
import { toSearchQuery } from '../../common/utils/assetQuery';
import { ThemeQuery } from '../../themes/records/ThemeQuery';
import AssetResultsSectionDataContainer from '../../storefront/components/AssetResultsSectionDataContainer';
import RouterFilterButton from '../../common/components/RouterFilterButton';
const MAX_RECOMMENDATION_COUNT = 3;
export default function ThemeRecommendations({
  businessTypes,
  isPreview,
  offeringId,
  onTrackInteraction,
  onTrackPageview,
  providerName
}) {
  const {
    textAlign
  } = useResponsiveProps({
    textAlign: {
      xs: 'left'
    }
  });
  const businessTypesQuery = useMemo(() => new ThemeQuery({
    businessTypes,
    limit: MAX_RECOMMENDATION_COUNT + 1
  }), [businessTypes]);
  const businessTypesSeeAllMessage = useMemo(() => {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.details.recommendations.seeAllBusinessTypes",
      options: {
        businessTypes: I18n.formatList(businessTypes.map(businessType => I18n.text(getAssetBusinessTypeI18nKey(businessType))))
      }
    });
  }, [businessTypes]);
  const businessTypesTitle = useMemo(() => {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.details.recommendations.businessTypesTitle",
      options: {
        businessTypes: I18n.formatList(businessTypes.map(businessType => I18n.text(getAssetBusinessTypeI18nKey(businessType))))
      }
    });
  }, [businessTypes]);
  const providerQuery = useMemo(() => new ThemeQuery({
    providers: [providerName],
    limit: MAX_RECOMMENDATION_COUNT + 1
  }), [providerName]);
  const trackInteraction = useCallback((action, eventProperties = {}) => {
    onTrackInteraction(action, Object.assign({}, eventProperties, {
      section: 'recommendations'
    }));
  }, [onTrackInteraction]);
  const trackPageview = useCallback(eventProperties => {
    onTrackPageview(eventProperties);
  }, [onTrackPageview]);
  const renderRecommendationRouter = useCallback((message, themeQueryField, queryValue) => /*#__PURE__*/_jsxs(RouterFilterButton, {
    disabled: isPreview,
    onClick: () => trackInteraction('click see all link'),
    queryField: themeQueryField,
    style: {
      textAlign
    },
    value: queryValue,
    use: "transparent",
    children: [message, /*#__PURE__*/_jsx(UIIcon, {
      name: "right",
      size: "xxs",
      color: CALYPSO
    })]
  }), [isPreview, textAlign, trackInteraction]);
  return /*#__PURE__*/_jsx(MainSection, {
    responsive: true,
    children: /*#__PURE__*/_jsxs(MainSectionInner, {
      children: [/*#__PURE__*/_jsx(AssetResultsSectionDataContainer, {
        maxColumns: MAX_RECOMMENDATION_COUNT,
        offeringId: offeringId,
        responsive: true,
        searchQuery: toSearchQuery(providerQuery),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.details.recommendations.providerTitle",
          options: {
            providerName
          }
        }),
        titleControls: renderRecommendationRouter( /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.details.recommendations.seeAllProviders",
          options: {
            providerName
          }
        }), ThemeQueryField.PROVIDERS, providerName),
        trackInteraction: trackInteraction,
        trackPageview: trackPageview
      }), /*#__PURE__*/_jsx(AssetResultsSectionDataContainer, {
        maxColumns: MAX_RECOMMENDATION_COUNT,
        offeringId: offeringId,
        responsive: true,
        searchQuery: toSearchQuery(businessTypesQuery),
        title: businessTypesTitle,
        titleControls: renderRecommendationRouter(businessTypesSeeAllMessage, ThemeQueryField.BUSINESS_TYPES, businessTypes),
        trackInteraction: trackInteraction,
        trackPageview: trackPageview
      })]
    })
  });
}